import { createElement as e } from "react";
import { Switch, Route } from "react-router";
import Header from "../components/Header";
import { Navbar, Nav, Glyphicon } from "react-bootstrap";
import AccountNav from "../components/AccountNav";
import NavItemLink from "sc/ui/components/NavItemLink";
import Queues from "../pages/tech/Queues";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";

const Menu = () =>
  e(
    Navbar.Collapse,
    { className: "pull-right" },
    e(
      Nav,
      null,
      e(
        NavItemLink,
        { eventKey: "1", href: "/" },
        e(Glyphicon, { glyph: "glyphicon glyphicon-home" }),
        " Queues",
      ),
    ),
    e(Nav, null, e(AccountNav)),
  );

export default () =>
  e(
    "div",
    null,
    e(Header, { MenuComponent: Menu }),
    e(
      Switch,
      null,
      e(Route, { path: "/", component: Queues, exact: true }),
      e(Route, { path: "*", component: PageNotFound, exact: true }),
    ),
  );



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/routes/Tech.js